import React from 'react';
import PropTypes from 'prop-types';

export const TopAlertUwaga = (props) => {
    return (
        <p style={Boolean(props.inline)? {color:'firebrick', display:'inline', marginLeft:'10px'}:{color:'firebrick'}}><i className={props.icon}></i> {props.text}</p>
    );
};

TopAlertUwaga.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.string,
    inline:PropTypes.bool,
};

TopAlertUwaga.defaultProps = {
    text: 'Brak danych do załadowania',
    icon: 'fa fa-exclamation-circle',
    inline:false,
};

export const TopAlertOstrzezenie = (props) => {
    return (
        <p style={Boolean(props.inline)? {color:'peru', display:'inline', marginLeft:'10px'}:{color:'peru'}}><i className={props.icon}></i> {props.text}</p>
    );
};

TopAlertOstrzezenie.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.string,
    inline:PropTypes.bool,

};

TopAlertOstrzezenie.defaultProps = {
    text: 'Brak danych do załadowania',
    icon: 'fa fa-exclamation-circle',
    inline:false,

};

export const TopAlertInformacja = (props) => {
    return (
        <p style={Boolean(props.inline)? {color:'dodgerblue', display:'inline', marginLeft:'10px'}:{color:'dodgerblue'}}><i className={props.icon}></i> {props.text}</p>
    );
};

TopAlertInformacja.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.string,
    inline:PropTypes.bool,
};

TopAlertInformacja.defaultProps = {
    text: 'Brak danych do załadowania',
    icon: 'fa fa-info-circle',
    inline:false,
};

export const TopAlertSukces = (props) => {
    return (
        <p style={Boolean(props.inline)? {color:'forestgreen', display:'inline', marginLeft:'10px'}:{color:'forestgreen'}}><i className={props.icon}></i> {props.text}</p>
    );
};

TopAlertSukces.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.string,
    inline:PropTypes.bool,
};

TopAlertSukces.defaultProps = {
    text: 'Pomyślnie wykonano żądane akcje',
    icon: 'fa fa-check-circle',
    inline:false,
};




// WEBPACK FOOTER //
// ./src/componentsTopsa/alerty/TopAlerts.js